import { appState } from './appState';
import { storage } from './storage';
const PROJECT_ENTITY_MAP_PREFIX = 'blindquery_project_entity_maps_';
let cachedProjectId = null;
let cachedProjectSnapshot = null;
export function serializeEntityMaps(entityMaps) {
    const snapshot = {};
    for (const [type, map] of entityMaps.entries()) {
        snapshot[type] = {};
        for (const [original, tag] of map.entries()) {
            snapshot[type][original] = tag;
        }
    }
    return snapshot;
}
export function filterEntityMapsByText(snapshot, text) {
    const filtered = {};
    Object.entries(snapshot).forEach(([type, entries]) => {
        const matches = {};
        Object.entries(entries).forEach(([original, tag]) => {
            if (text.includes(tag)) {
                matches[original] = tag;
            }
        });
        if (Object.keys(matches).length > 0) {
            filtered[type] = matches;
        }
    });
    return filtered;
}
export function deanonymizeWithSnapshot(text, snapshot) {
    if (!snapshot) {
        return text;
    }
    let result = text;
    for (const map of Object.values(snapshot)) {
        for (const [original, tag] of Object.entries(map)) {
            const escapedTag = tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(escapedTag, 'g');
            result = result.replace(regex, original);
        }
    }
    return result;
}
function buildProjectEntityMapKey(projectId) {
    return `${PROJECT_ENTITY_MAP_PREFIX}${projectId}`;
}
export async function loadProjectEntityMap(projectId) {
    if (cachedProjectId === projectId && cachedProjectSnapshot) {
        return cachedProjectSnapshot;
    }
    const snapshot = await storage.load(buildProjectEntityMapKey(projectId), { encrypted: true });
    cachedProjectId = projectId;
    cachedProjectSnapshot = snapshot;
    return snapshot;
}
export async function saveProjectEntityMap(projectId, snapshot) {
    cachedProjectId = projectId;
    cachedProjectSnapshot = snapshot;
    await storage.save(buildProjectEntityMapKey(projectId), snapshot, { encrypted: true });
}
export function clearProjectEntityMapCache() {
    cachedProjectId = null;
    cachedProjectSnapshot = null;
}
export async function deleteProjectEntityMap(projectId) {
    if (cachedProjectId === projectId) {
        clearProjectEntityMapCache();
    }
    storage.remove(buildProjectEntityMapKey(projectId));
}
export async function ensureProjectEntityContext(projectId) {
    if (!appState.entityContext) {
        return;
    }
    if (!projectId) {
        cachedProjectId = null;
        cachedProjectSnapshot = null;
        appState.entityContext.loadFromSnapshot({});
        return;
    }
    if (cachedProjectId === projectId && cachedProjectSnapshot) {
        appState.entityContext.loadFromSnapshot(cachedProjectSnapshot);
        return;
    }
    const snapshot = await loadProjectEntityMap(projectId);
    if (snapshot) {
        appState.entityContext.loadFromSnapshot(snapshot);
    }
    else {
        appState.entityContext.loadFromSnapshot({});
    }
}
export function resolveEntityMapSnapshot() {
    return appState.currentEntityMaps ?? null;
}
